import { Api } from '@/src/store/api'

export const PointsToOmniApi = Api.enhanceEndpoints({
  endpoints: {
    'POST /points/transfer': {
      invalidatesTags: [
        'GET /card/accounts/:cardAccountId',
        'GET /card/activity-feed/:cardAccountId',
      ],
    },
  },
})
